import React from 'react';
import {Tooltip} from 'react-bootstrap';
import './style.css';

const tooltips = {
	"bg_removal": (
		<Tooltip className='custom-tooltip' id="bg_removal_tooltip">
        	Toggle background removal
    	</Tooltip>
    ),
    "flip": (
		<Tooltip className='custom-tooltip' id="flip_tooltip">
        	Flip
    	</Tooltip>
    ),
    "crop": (
		<Tooltip className='custom-tooltip' id="crop_tooltip">
        	Crop
    	</Tooltip>
    ),
    "edit_mockup": (
		<Tooltip className='custom-tooltip' id="edit_mockup_tooltip">
        	Edit Mockup
    	</Tooltip>
    ),
    "photo_editor": (
		<Tooltip className='custom-tooltip' id="photo_editor_tooltip">
        	Photo Editor
    	</Tooltip>
    ),
    "position": (
		<Tooltip className='custom-tooltip' id="position_tooltip">
        	Position
    	</Tooltip>
    ),
    "transparency": (
		<Tooltip className='custom-tooltip' id="transparency_tooltip">
        	Transparency
    	</Tooltip>
    ),
    "lock": (
		<Tooltip className='custom-tooltip' id="lock_tooltip">
        	Lock
    	</Tooltip>
    ),
    "unlock": (
		<Tooltip className='custom-tooltip' id="unlock_tooltip">
        	Unlock
    	</Tooltip>
    ),
    "copy": (
		<Tooltip className='custom-tooltip' id="copy_tooltip">
        	Copy
    	</Tooltip>
    ),
    "delete": (
        <Tooltip className='custom-tooltip' id="delete_tooltip">
            Delete
        </Tooltip>
    ),
	"animate": (
		<Tooltip className='custom-tooltip' id="animate_tooltip">
			Animate
		</Tooltip>
	)
}


export default tooltips